var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFantomLight = function SvgFantomLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6 32c8.836 0 16-7.163 16-16s-7.164-16-16-16C7.763 0 .6 7.163.6 16s7.163 16 16 16Z",
    fill: "#1969FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m17.802 12.9 3.6-2.1V15l-3.6-2.1Zm3.6 9-4.8 2.8-4.8-2.8V17l4.8 2.8 4.8-2.8v4.9Zm-9.6-11.1 3.6 2.1-3.6 2.1v-4.2Zm5.4 3.1 3.6 2.1-3.6 2.1v-4.2Zm-1.2 4.2-3.6-2.1 3.6-2.1v4.2Zm4.8-8.3-4.2 2.4-4.2-2.4 4.2-2.5 4.2 2.5Zm-10.2-.4v13.1l6 3.4 6-3.4V9.4l-6-3.4-6 3.4Z",
    fill: "#fff"
  })));
};
export default SvgFantomLight;